import { Vue, Component, Model } from 'vue-property-decorator';

import style from './index.module.scss';

@Component
export default class Checkbox extends Vue {
  @Model('change', {
    type: Boolean,
  }) readonly checked!: boolean

  private render() {
    return (
      <span
        class={this.checked ? style.checked : style.checkbox}
        onClick={() => this.$emit('change', !this.checked)}
      />
    );
  }
}
